/**
 * Protocol that's used to communicate between mobile browser and mobile application via deep links.
 */
export const APP_SCHEME = 'eloomi://';
